import { useState, useContext, useEffect, useRef } from "react"
import { BtnLoader, CSelect, toast, CInputText, CInputPassword, CToggle, CModal } from "../../../components/widget"
import { ContextNav, ContextDashboard, ContextLoading } from "../../../context";
import { VcationReasonsEditApi, SingleVcationReasonsApi } from "../../../api";
import { useNavigate } from "react-router-dom";
import { useParams, Link } from "react-router-dom";

export const VcationReasonsEdit = () => {
    const navigate = useNavigate()
    const formRef: any = useRef()
    const CtxNav = useContext(ContextNav)
    const CtxLoad = useContext(ContextLoading)
    let params = useParams();
    const [singleData, setSingleData] = useState<any>(null)


    const onFinish = async (e: any) => {
        e.preventDefault()
        CtxLoad.setDisplayLoadingBtn(true)
        let res = await VcationReasonsEditApi(formRef, singleData)
        CtxLoad.setDisplayLoadingBtn(false)
        if (res.success) {
            toast('ویرایش موفقیت آمیز بود', { type: "success" })
            navigate('/p/settings/vacation-reasons');
        }
        else {
            toast(res.message, { type: "error" })
        }
    }


    const getData = async () => {
        CtxLoad.setDisplayLoadingBlur(true)
        let res = await SingleVcationReasonsApi(params.id)
        if (res.success) {
            setSingleData(res.data)
            formRef.current['reason'].value = res.data.title;
            CtxLoad.setDisplayLoadingBlur(false)
        }
        else {
            CtxLoad.setDisplayLoadingBlur(false)
        }
    }


    useEffect(() => {
        document.title = "ویرایش علت مرخصی | دایان"
        CtxNav.setActiveMenuItem({ 'item': 3, 'subItem': 5, })
        getData()
    }, [])

    return (
        <div className=" w-full flex flex-col">
            <h1 className="sm:text-2xl text-lg font-bold mb-[30px]">ویرایش علت مرخصی</h1>

            <form ref={formRef} onSubmit={onFinish} className=" w-full  flex flex-col shadow sm:rounded-xl rounded-lg bg-white py-[15px] sm:py-[30px] sm:px-[20px] px-[10px]">


                <div className=" w-full flex flex-col md:flex-row items-center mt-[15px] sm:mt-[40px] border-b pb-[15px] sm:pb-[30px]">
                    <div className=" w-full   flex flex-col sm:flex-row items-center">
                        <div className=" w-full sm:w-[50%] h-[50px] flex sm:mt-0 mt-5 items-center pl-0 sm:pl-2 relative">
                            <div className=" w-full h-[50px] pl-1 sm:pl-2">
                                <CInputText name="reason" title="علت مرخصی" type="text" required={true} />
                            </div>
                        </div>
                    </div>
                </div>


                <div className=" w-full mt-[40px] flex items-center">
                    {CtxLoad.displayLoadingBtn ?
                        <button type="button" className="w-[100px] h-[40px] bg-dayan-gray-200 text-white rounded-[5px] text-sm shadow cursor-not-allowed relative flex justify-center items-center"><BtnLoader /></button>
                        :
                        <button type="submit" className="w-[100px] h-[40px] bg-dayan-gray-200 text-white rounded-[5px] text-sm shadow">اعمال</button>
                    }
                    <Link to='/p/settings/vacation-reasons'>
                        <button type="button" className="w-[100px] h-[40px] bg-[#a4a4a4] text-dayan-gray-200 rounded-[5px] mr-3 text-sm shadow">بازگشت</button>
                    </Link>
                </div>

            </form>



        </div>
    )
}
